import { useIntl } from "react-intl";

import { useSearchParameters } from "@/components/signup/hooks";
import { ProductKey } from "@/components/signup/utils";
import { CardsGrid } from "@/templates/ondemand/signup/confirmation/confirmation-page/src/views/user-seg-bxp-ui/cards-grid.tsx";

import {
    JiraOnboardingContainer,
    TwcOnboardingContainer
} from "../../components/jira-onboarding-container/jira-onboarding-container";
import {
    useRegisterMetadata,
    experiment
} from "../../hooks/use-registered-metadata";

type MessagesType = {
    readonly teamFocus: string;
    readonly personalizeJira: string;
};

const TeamFocusView = () => {
    const intl = useIntl();
    const searchParameters = useSearchParameters();
    const { products = [] } = searchParameters;

    const metadata = useRegisterMetadata();

    const isJsm = products.includes(ProductKey.JIRA_SERVICE_MANAGEMENT);
    const isTwc = products.includes(ProductKey.TEAMWORK_COLLECTION);

    if (isTwc) {
        const d0JtbdExperimentCohort = metadata?.get(
            experiment.d0JtbdOnboarding.cohort
        );

        let header: string;
        let subheader: string;
        if (d0JtbdExperimentCohort === "variation") {
            header = intl.formatMessage({
                id: "UserSeg.teamTypeSelection.twc.jtbdD0onboarding.header",
                defaultMessage: "What kind of work do you do?"
            });
            subheader = intl.formatMessage({
                id: "UserSeg.teamTypeSelection.twc.jtbdD0onboarding.subHeader",
                defaultMessage: "This helps us personalize your experience."
            });
        } else {
            header = intl.formatMessage({
                id: "UserSeg.teamTypeSelection.twc.header",
                defaultMessage: "First, let's start with a project in Jira"
            });
            subheader = intl.formatMessage({
                id: "UserSeg.teamTypeSelection.twc.subHeader",
                defaultMessage:
                    "Choose the team that best reflects what you do for work. This helps us personalize how you'll get started."
            });
        }

        return (
            <TwcOnboardingContainer header={header} subheader={subheader}>
                <CardsGrid />
            </TwcOnboardingContainer>
        );
    }

    const messages: MessagesType = isJsm
        ? {
              teamFocus: intl.formatMessage({
                  id: "UserSeg.teamTypeSelection.header",
                  defaultMessage: "What kind of work do you do?"
              }),
              personalizeJira: intl.formatMessage({
                  id: "UserSeg.teamTypeSelection.jsm.subHeader",
                  defaultMessage: "This helps us personalize your experience"
              })
          }
        : {
              teamFocus: intl.formatMessage({
                  id: "UserSeg.teamTypeSelection.header",
                  defaultMessage: "What kind of work do you do?"
              }),
              personalizeJira: intl.formatMessage({
                  id: "UserSeg.teamTypeSelection.transparentTemplateForAll.subHeader",
                  defaultMessage:
                      "This helps us suggest templates that help your team do their best work."
              })
          };

    return (
        <JiraOnboardingContainer
            header={messages.teamFocus}
            subheader={messages.personalizeJira}
        >
            <CardsGrid />
        </JiraOnboardingContainer>
    );
};

export default TeamFocusView;
